<template>
    <div style="width: 1120px;margin: 0 auto;">
        <div style="width: 1120px;margin: 0 auto;z-index: 1;position: relative;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/NQI' }">NQI站点</el-breadcrumb-item>
                <el-breadcrumb-item>{{ region?name:'' }}站点信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="padding: 15px;">
            <div class="service-card" v-for="value in regionServiceList" style="margin-top: 10px;" @click="jumpAct(value)">
                <!-- 左侧图标 -->
                <img src="../../assets/img/serviceOrganization/cardHome.png" alt="机构图标" class="card-icon">

                <div class="card-content">
                <!-- 标题行 -->
                <div class="card-title-row">
                    <h3 class="card-title">{{ value.name }}</h3>
                    <span class="entity-tag">{{ value.type }}</span>
                </div>

                <!-- 特色产业 -->
                <div class="card-row">
                    <span class="label">特色产业：</span>
                    <span class="value">{{ value.tscy }}</span>
                </div>

                <!-- 简介 -->
                <div class="card-row" @click.stop="openDialog(value.briefintroduction)">
                    <span class="label">简介：</span>
                    <!--  :title="value.briefintroduction" -->
                    <span class="value" style="cursor: pointer;">{{ value.briefintroduction }}</span>
                </div>

                <!-- 联系方式和地址 -->
                <div class="card-info-row">
                    <div class="info-item">
                    <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <span class="info-text">联系方式:{{ value.phone || '' }}</span>
                    </div>
                    <div class="info-item">
                    <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span class="info-text">地址:{{ value.address }}</span>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <el-dialog
          append-to-body
          title=""
          :visible.sync="certDialogShow"
          width="1120px"
          @close="closeCertDialog"
        >
          <div>
            <span style="white-space: break-spaces;display: flex;line-height: 1.5;text-align: left;">{{ nowText }}</span>
          </div>
        </el-dialog>
    </div>
</template>

<script>
import { Server, httpurl } from '@/server';
export default {
  name: 'MapServicePage',
  data() {
    return {
      region:'', 
      regionServiceList: [],
      certDialogShow: false,
      nowText:'',
    }
  },
  mounted() {
    this.region = this.$route.query.region
    this.name = this.$route.query.name
    this.getNQIQYList()
  },
  methods: {
    getNQIQYList() {
        let params = {
            pageSize:-1
        }
        if (this.region) {
            params.region = this.region
        }
        Server.getNQIQYList(params).then(res => {
            if (res.success) {
                console.log(res);
                this.regionServiceList = res.result.records
            }
        })
    },
    back() {
        this.$router.go(-1)
    },
    jumpAct(item) {
      if (item.outsidechain) {
          window.open(item.outsidechain,'_blank')
      }
      else if (item.website) {
          this.$router.push({
              path: item.website
          })
      }
    },
    openDialog(str) {
      if (!str) {
        return
      }
      console.log('点击触发弹窗');
      this.nowText = str
      this.certDialogShow = true;
    },
     // 关闭弹窗
    closeCertDialog() {
      this.certDialogShow = false
    }
  },
}
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  border-radius: 10px;
}
.map-page {
  width: 100%;
  min-height: 100vh;
  position: relative;
}

.bg-layer {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/NQR/layer_bg.png") no-repeat center top;
  background-size: cover;
  z-index: 0;
}

.content-container {
  position: relative;
  z-index: 1;
  max-width: 1120px;
  margin: 0 auto;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 30px;
}

.map-section {
  position: relative;
}
.zibo-map {
  width: 100%;
  height: auto;
  display: block;
}

/* 右侧列表 */
.list-section {
  width: 45%;
  margin-left: 70px;
}
.list-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 5px 24px;
  height: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.list-item {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  padding: 7px 0;
  border-bottom: 1px solid #f2f2f2;
}
.list-item:last-child {
  border-bottom: none;
}

/* 弹框样式 */
.map-popup {
  position: absolute;
  width: 350px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  z-index: 999;

  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
}
.popup-title {
  font-size: 14px;
  font-weight: bold;
  color: #2b7de9;
  margin-bottom: 6px;
  text-align: center;

  width: 100%;
}
.popup-content {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  text-align: center;
}
.service-card {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  gap: 16px;
}

.card-icon {
  width: 25px;
  height: 25px;
  flex-shrink: 0;
  margin-top: -5px;
}

.card-content {
  flex: 1;
  min-width: 0; /* 必须加，否则省略不生效 */
}

.card-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.card-title {
  margin: 0;
  font-size: 15px;
  font-weight: bold;
  color: #222;
}

.entity-tag {
  background: #e0edff;
  color: #4080ff;
  font-size: 13px;
  padding: 4px 12px;
  border-radius: 6px;
}

.card-row {
  margin: 8px 0;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.label {
  color: #333;
  white-space: nowrap;
}

/* ✅ 正确的单行省略 */
.value {
  color: #333;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-info-row {
  display: flex;
  gap: 60px;
  margin-top: 16px;
  font-size: 12px;
  color: #666;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-icon {
  width: 18px;
  height: 18px;
  color: #666;
}
.popup-arrow {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
}
</style>